<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre11" id="pgepubid00011"><a class="calibre1" id="Chapter_2">CHAPTER II.</a></h3>
<h4 class="calibre8 sigil_not_in_toc" id="pgepubid00012">THE CHILD.</h4>
<p class="calibre3">GEORGE did not continue reading after his wife had made her way to
the water’s edge, some few yards distant. She was soon busily engaged
dabbling her hands in the clear water, so much occupied as to be
for the time oblivious of her fair surroundings. Yet they were very
beautiful.</p>
<p class="calibre3">Leo had betaken himself to a steep, rounded bill on the other side of
the valley, where he could be seen, vigorously ascending. George would
have liked to perform that ascent himself; but he knew that the climb
would be quite beyond Dulcie’s limited powers, and that she would not
be happy to remain behind. So he kept his seat, giving himself up to
a dreamy enjoyment which was after all quite as much in his line as
the more active enjoyment of bodily exercise. George Rutherford was a
many-sided individual.</p>
<p class="calibre3">A scene lay around well worth attention. The river-bed showed golden
tintings, and green reflections from the opposite bank danced on the
ripples. Facing him were three hills, rising like great rounded billows
across the valley. The church, built of whitish-gray stone, with low,
square tower and slated roof, stood on a low level, almost at the
bottom of the valley, and quite at its centre, just between the “Castle
Hill,” which Leo was climbing, and George’s own position. Other hills
filled up the landscape, clothed in foliage, and trees grew abundantly
all along the course of the little babbling river. Glows of sunshine
came and went, with shady intervals between. The calm, soft repose of
the valley might well strike home to any heart.</p>
<p class="calibre3">Dulcie was not greatly affected by aspects of nature; but the calm and
sweetness sank deep into George Rutherford’s heart. She was only “a
few yards off, keeping up a little chatter, something like the pretty
babble of the water; and George was lost in thought, quite unconscious
of what she said, or of whether she said anything. He woke up at
length, to find her laughing at him.</p>
<p class="calibre3">“Why, Georgie, what are you thinking about?” she cried.</p>
<p class="calibre3">“Time for us to be moving,” George said, standing up. “That boy ought
to come back. How do you like my valley, Dulcie?”</p>
<p class="calibre3">“Too much shut in,” said Dulcibel promptly. “But it is pretty—and the
river is nice. I wish the poor in our towns could have such a water
supply. There comes Leo. Oh, we are not going back yet, Georgie! No use
to think of being in time for lunch, so we’ll just eat my sandwiches
here. I wish we had a bottle or two of soda-water.”</p>
<p class="calibre3">Dreamy enjoyment was over, and an hour of merriment ensued, Dulcie
being in high spirits, and allowing no time for enjoyment of reposeful
nature. Then at length she consented to a move, and a sigh broke from
her as to “that horrid bridge.”</p>
<p class="calibre3">“I see!” George began.</p>
<p class="calibre3">“Yes; I’ve been putting it off as long as possible; but I suppose we
must!” and Dulcie sighed again. “I shall never come to your valley a
second time, Georgie. Horrid place! I can’t endure that bridge. Is
there really no other way out?”</p>
<p class="calibre3">“Not within your powers of walking, Dulcie. And if there were—” George
paused, with a curious expression in his brown eyes—“I should like my
wife to be not quite so readily beaten.”</p>
<p class="calibre3">“Oh, I’m not the least proud, Georgie dear! I’d give in willingly.”</p>
<p class="calibre3">But George took the empty basket, and gave her his arm; and she had to
follow his lead.</p>
<p class="calibre3">The bridge reached, they came all at once to a very unexpected sight.
A little girl was there, entirely alone, possibly three or four years
old, seated composedly on the grass close beside the bridge, her plump
hands folded. She did not give the strangers a look of welcome. A pair
of black velvety eyes gazed hard as they approached, and the black
brows above drew into a forbidding frown, odd on that infantine face,
while the full red lips pouted in correspondence.</p>
<p class="calibre3">“Why, Georgie, who can the little thing be?”</p>
<p class="calibre3">Dulcibel knelt straight down on the grass, and asked the child’s name.
No answer was vouchsafed. The black eyes glowered at Dulcie, and the
black brows frowned more heavily.</p>
<p class="calibre3">“Georgie, she’s a darling,” cried the forgiving Dulcie. “Just see what
lovely eyes! She’s as dark as a gypsy. And how nicely the little pet is
dressed! She isn’t a poor child, Georgie. She must belong to a lady.
But fancy leaving her here! Why, she might have fallen into the river.
What a mercy we came back this way! Now, you little dear, do tell me;
what is your name?”</p>
<p class="calibre3">“Whom do you belong to, my dear?” asked George, as Dulcibel’s most
winning smile met only with another scowl from the rich dark eyes and
brows.</p>
<p class="calibre3">“Don!” came at last solemnly.</p>
<p class="calibre3">“John?” hazarded George.</p>
<p class="calibre3">“Or—Gone,” suggested Dulcibel.</p>
<p class="calibre3">“Don!” was solemnly reiterated.</p>
<p class="calibre3">“She likes you better than me, Georgie, dear. She doesn’t frown at you
half so fiercely,” said Dulcibel.</p>
<p class="calibre3">George seemed flattered, and he bent low over the small piece of
composed and sedate humanity.</p>
<p class="calibre3">“What is your name, my dear?” he asked. “Eh? Couldn’t you manage to say
it? What do they call you? Not ‘Baby,’ I expect. You are too old to be
baby! Come, tell your name, won’t you? Tell me!”</p>
<p class="calibre3">George looked indescribably coaxing, and the drawn brows relaxed in
some degree.</p>
<p class="calibre3">“What’s your name, eh?” repeated George.</p>
<p class="calibre3">“Doan!” came at length, with clear incisive utterance.</p>
<p class="calibre3">“Joan; John and Joan! Yes, it must be that.”</p>
<p class="calibre3">“If it isn’t Gone, and Don’t,” said George. He rubbed his head, and
combed out his long silky beard with perplexed fingers. “Here my little
dear,” he said, stooping again, “tell me now, won’t you? Where’s
mother?”</p>
<p class="calibre3">Silence.</p>
<p class="calibre3">“What on earth are we to do?” asked George.</p>
<p class="calibre3">“Take her to the hotel,” suggested Leo.</p>
<p class="calibre3">“There’s no hurry about going back,” observed Dulcibel, delighted to
put off the evil moment of bridge crossing. “It won’t take us more than
an hour to walk.”</p>
<p class="calibre3">“Depends on speed,” muttered George.</p>
<p class="calibre3">“And somebody is sure to come soon to find her. She must have wandered
away from a party of tourists. We must just stay and keep guard till
they appear. It is quite impossible to leave the little mite alone.
Perhaps she will sit on my lap.”</p>
<p class="calibre3">But a touch from Dulcibel brought an immediate howl—not a tearful cry,
only one loud, distinct shout of protest, with an accompanying scowl.</p>
<p class="calibre3">“I’m afraid she has a temper,” said Dulcie, rather alarmed.</p>
<p class="calibre3">Delay being decided upon, Dulcibel sat down, and George wandered about
near at hand, repeatedly coming back to observe with curious eyes the
solemn, black-eyed infant, seated pompously apart, with folded hands
and calm demeanor. Leo tried his hand next, very cautiously. He drew
near, and made funny grimaces, and snapped his fingers, and tossed
leaves into her lap. She flung the leaves back at him, frowning still;
but presently a dimple appeared in the rounded red-brown cheek, and the
beautiful black eyes lighted up with a smile. Leo offered a biscuit,
only to have it thrown back in his face with a renewed scowl. George
meanwhile crossed the bridge, and vainly explored the neighborhood for
tracks or traces of somebody. Presently, finding Leo still baffled by
the little creature’s resolute unfriendliness, he came near himself,
and with a quick movement lifted her straight up into his strong arms.
One indignant shout rose, and then she seemed to submit—nay, seemed
rather to like her new position.</p>
<p class="calibre3">“Poor wee mite!” said George. “Now, my little dear, tell me, where’s
mother?”</p>
<p class="calibre3">“Don!” was this time very distinct.</p>
<p class="calibre3">“When will she come back? Did she tell you to wait here?” A nod. “Come
that’s better. Did mother go to speak to somebody?” No response. “Did
mother say she would be back soon?” No response. “How soon is mother
coming. Don’t you know? Ah, I thought not!” as the black head was
decisively shaken. “Dear me, how strange of mother to leave you here,
all alone! And your name is Joan, isn’t it?” Another nod. “I thought
so. Joan will have to come home with us, and be taken care of, till
mother can be found.”</p>
<p class="calibre3">No answer; but Joan seemed extremely comfortable in his arms. A drowsy
look was creeping into the black eyes, as if the poor little mind had
been long on the stretch and needed rest. While George stood holding
her, she laid her head down on his broad shoulder, and went to sleep.</p>
<p class="calibre3">“Poor wee lamb!” murmured George, quite touched.</p>
<p class="calibre3">“But where can the mother be?” asked Dulcibel.</p>
<p class="calibre3">“I hope nothing has happened to her. A most extraordinary proceeding,
anyhow, to leave the child alone here. If it were not such a
canny little being it might have fallen into the river and been
drowned—nothing more likely! I cannot understand any mother acting in
such a way, and why she has not come back.”</p>
<p class="calibre3">“I don’t suppose she intends to come back,” pronounced Dulcie. “Well,
I call this quite an adventure—quite a romance! And I shall not be
the least surprised if nothing more is heard of the mother—horrid,
heartless, wicked creature.”</p>
<p class="calibre3">“If it really were so. But we do not know yet, Dulcie. It may be only a
case of heinous thoughtlessness.”</p>
<p class="calibre3">“Or of drink.”</p>
<p class="calibre3">“No need yet to believe the worst.”</p>
<p class="calibre3">“But to think of her leaving the little pet at all—such cruelty!
Ninety-nine children in a hundred would be out of their wits with
fright, or would wander away and get quite lost. And she might catch
her death of cold on the damp grass. Oh, you needn’t defend the woman,
Georgie, dear! I have no patience with such unmotherly, heartless ways.”</p>
<p class="calibre3">George had not the slightest intention of defending a course of action
which only aroused in him deeper, though quieter indignation than in
Dulcie; and he held his peace.</p>
<p class="calibre3">The short frock hung loosely, and Dulcibel caught sight of a small
pocket. It was a neat print frock, nicely made; and indeed the child’s
whole appearance spoke of affectionate care. Dulcibel’s slim fingers
dived into the pocket, bringing out thence a tiny pocket handkerchief
and a minute red pencil. On the handkerchief were the initials “J. B.,”
and on the pencil, where a flat place had been cut for the purpose, was
printed the single word “Joan.”</p>
<p class="calibre3">“That is her name, then,” said Leo. “What a jolly little face she has,
uncle—and such black eyelashes!”</p>
<p class="calibre3">“Little lamb!” George said again, pityingly. “Well, there’s nothing to
be done that I can see, except to take her to the hotel. One cannot
leave her here. Leo, my hands are not free. Just tear a page out of my
pocket-book—you’ll find it in the right hand pocket—and write—‘Child
Joan found: safe at hotel;’ and give our address in full. Then pin it
firmly to the bridge. Your aunt is sure to have plenty of pins. Or
tie it—yes, that is better. Of course a boy has string. We must take
back the church key to the cottage, and we can leave word there also.
Perhaps we may hear something about the mother. If not, I shall have
to make inquiries to-morrow. Dulcie, my dear, you must hold on to my
coat-tails crossing the bridge. Or stay—you can slip your arm in mine.
Yes, she is a jolly little thing,” George added, looking down on the
dark, small face, with black lashes lying on the rosy cheeks.</p>
<p class="calibre3">Joan never stirred. She slept on, peacefully at rest in her new refuge.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?fa72ba6a